import React, { Component, Fragment } from 'react';
//import { getFormValues } from 'redux-form';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';

import { Button, Grid } from 'semantic-ui-react';

import { Filter, Main } from 'Containers';
import { ExportGrid } from './components/ExportGrid';

class NewYorkSirsExportContainer extends Component {
  onCreateExportClick = () => {
    this.props.history.push('/newyorksirsexport/0');
  };

  render() {
    return (
      <Fragment>
        <Filter title={'New York SIRS Export'}>
          <Grid>
            <Grid.Row column={2}>
              <Grid.Column width={12} />
              <Grid.Column width={4} floated={'right'} textAlign={'right'}>
                <Button
                  content="Create New"
                  type={'button'}
                  onClick={this.onCreateExportClick}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Filter>
        <Main shouldNotUsePageWidth>
          <ExportGrid />
        </Main>
      </Fragment>
    );
  }
}

export const NewYorkSirsExport = withRouter(
  connect()(NewYorkSirsExportContainer)
);



// WEBPACK FOOTER //
// ./src/pages/newyorksirsexport/NewYorkSirsExport.js